import { mount } from 'svelte';
import ConfirmationAbonnementInfolettre from './abonnement-infolettre/ConfirmationAbonnementInfolettre.svelte';

mount(ConfirmationAbonnementInfolettre, {
  target: document.getElementById('confirmation-abonnement-infolettre')!,
});
